export default __webpack_public_path__ + "static/media/Page_61.dad9b767.jpg";